<div class="form-check">
    <input
      type="radio"
      class="form-check-input"
      [id]="id"
      [name]="name"
      [value]="value"
      [checked]="isChecked"
      (change)="onChange($event)"
    />
    <label class="form-check-label" [for]="id">{{ label }}</label>
  </div>
  
